export class RefreshGeneration {
  constructor() {
    this.generation = 0;
  }

  begin() {
    this.generation += 1;
    return this.generation;
  }

  invalidate() {
    this.generation += 1;
  }

  isCurrent(ticket) {
    return Number.isInteger(ticket) && ticket === this.generation;
  }

  apply(ticket, mutation) {
    if (!this.isCurrent(ticket)) return false;
    mutation();
    return true;
  }
}
